import Button from "@mui/material/Button";
import ConfirmationDialog from "../Components/Dialogs/ConfirmationDialog";

const RenderGoBackButton = (isEqual, handleCancelEdit) => (
    isEqual ? (
        <Button
            className={'go-back-button'}
            variant='text'
            onClick={handleCancelEdit}
        >
            Back
        </Button>
    ) : (
        <ConfirmationDialog
            header="Cancel Editing"
            title="Are you sure you want to cancel editing?"
            description="Any changes will be lost."
            response={handleCancelEdit}
        >
            {(showDialog) => (
                <Button
                    variant='text'
                    className={'go-back-button'}
                    onClick={showDialog}
                >
                    Back
                </Button>
            )}
        </ConfirmationDialog>
    )
);

export default RenderGoBackButton;